import React, { useCallback, useEffect, useState } from "react";
import { Configurations } from "../../../Utils/Configurations";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import './Cile-Content.scss';
import axios from "axios";
import { withRouter } from 'react-router-dom';
import ImagemFukyo from "../../../Components/Imagem-Fukyo/Imagem-Fukyo";
import { SingleDatePicker } from "react-dates";
import moment from "moment";

const CileContentBannersDetails = (props) => {

    const [loading, setLoading] = useState(false)
    const [formState, setFormState] = useState(props.location.state ? {
        imagem: props.location.state.imagem,
        url: props.location.state.link,
    } : {
        imagem: '',
        url: ''
    })

    const [image, setImage] = useState()
    const [imageName, setImageName] = useState(null)
    const [temArquivo, setTemArquivo] = useState(false)
    const [loadingSalvar, setLoadingSalvar] = useState(false)
    const [youtube, setYoutube] = useState(false)
    const [arquivoSalvo, setArquivoSalvo] = useState(false)
    const [mensagemSalvar, setMensagemSalvar] = useState(false)
    const [modalSuccessYoutube, setModalSuccessYoutube] = useState(false)
    const [focusedI, setFocusedI] = useState(false);
    const [focusedF, setFocusedF] = useState(false);
    const [dataI, setDataI] = useState(props.location.state ? props.location.state.initial_date ? moment(props.location.state.initial_date) : null : null);
    const [dataF, setDataF] = useState(props.location.state ? props.location.state.end_date ? moment(props.location.state.end_date) : null : null);
    const [checked, setChecked] = useState(false);
    const [tipo, setTipo] = useState("welcome");

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormState((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    const handleImageChange = (e) => {
        const { value } = e.target;
        setImageName(value)
    };

    const EditarBanner = () => {

        if (temArquivo && !arquivoSalvo) {
            return setMensagemSalvar(true)
        }
        const config = new Configurations();
        const _body = {
            "image": formState.imagem,
            "url": formState.url,
            "initial_date": moment(dataI).format('YYYY-MM-DD'),
            "end_date": dataF ? moment(dataF).format('YYYY-MM-DD') : null,
            "type": props.location.state.type
        };

        axios.put(config.apiBasePath + `/conteudo-cile/banners/atualiza/${props.location.state.id}`, _body)
            .then(() => {
                setLoading(true)

            }).catch(error => {
                console.log("ERROR: ", error)
            })
            .finally(() =>
                setModalSuccessYoutube(true)
            )
    }

    const AdicionarBanner = () => {

        if (temArquivo && !arquivoSalvo) {
            return setMensagemSalvar(true)
        }
        const config = new Configurations();
        const _body = {
            "image": formState.imagem,
            "url": formState.url,
            "initial_date": moment(dataI).format('YYYY-MM-DD'),
            "end_date": dataF ? moment(dataF).format('YYYY-MM-DD') : null,
            "type": tipo
        };

        axios.post(config.apiBasePath + `/conteudo-cile/banners/novo`, _body)
            .then(() => {
                setLoading(true)

            }).catch(error => {
                console.log("ERROR: ", error)
            })
            .finally(() =>
                setModalSuccessYoutube(true)
            )
    }



    const onSelectFileImage = (e) => {
        setImage(e.target.files[0])
        setTemArquivo(true)
    }

    const salvarImg = async () => {
        const config = new Configurations();
        var bodyFormData = new FormData();
        bodyFormData.append('imagem', image);
        bodyFormData.append('tipo', 'banners');
        bodyFormData.append('nomeImagem', imageName);

        setLoadingSalvar(true)

        await axios.post(config.apiBasePath + `/cile/imagem/upload`, bodyFormData).then(response => {

            setFormState((prevState) => ({
                ...prevState,
                imagem: response.data.nameImage,
            }));

            setLoadingSalvar(false)

            setArquivoSalvo(true)

            // if (youtube) { setModalSuccessYoutube(true) }
        }).catch(err => {
            console.log("ERROR:", err)
            setLoadingSalvar(false)
        });
    }

    const { link } = props.location.state || '';

    const toggleModal = () => {
        setModalSuccessYoutube(!modalSuccessYoutube)
        window.history.go(-1)
    }

    useEffect(() => {
        setYoutube(props.location.state && props.location.state.type === 'youtube')
    }, [])

    const podeSalvar = () => {
        const urlValida = !!formState.url && formState.url.trim() !== "";
        const imagemValida = !!formState.imagem && formState.imagem.trim() !== "";
        const fluxoEdicao = !!props.location.state;

        const urlOriginal = fluxoEdicao ? props.location.state.url : null;
        const imagemOriginal = fluxoEdicao ? props.location.state.imagem : null;

        const urlAlterada = fluxoEdicao && formState.url !== urlOriginal;
        const imagemAlterada = fluxoEdicao && formState.imagem !== imagemOriginal;

        if (fluxoEdicao) {
            const houveAlteracao = urlAlterada || imagemAlterada || temArquivo;
            if (!urlValida) return false
            if (temArquivo && arquivoSalvo) {
                return houveAlteracao;
            } else {
                return houveAlteracao;
            }
        } else if (youtube || tipo === 'youtube') {
            return imagemValida && (temArquivo || arquivoSalvo);
        } else {
            return urlValida && imagemValida && (temArquivo || arquivoSalvo);
        }

    };

    const onDateChangeI = useCallback((date) => {
        setDataI(
            date && moment.isMoment(date) ? date : (date ? moment(date) : null)
        );
    }, []);
    const onDateChangeF = useCallback((date) => {
        setDataF(
            date && moment.isMoment(date) ? date : (date ? moment(date) : null)
        );
    }, []);
    const _outsideRange = (day) => {
        if (dataI) {
            return day.isSameOrBefore(dataI, 'day');
        } else {
            return day.isBefore(moment(), 'day');
        }

    };

    const handleChecked = (e) => {
        if (e.target.checked) {
            setDataF(null);
            setChecked(true);
        } else {
            setChecked(false);
        }
    }

    const handleChange = (event) => {
        setTipo(event.target.value);
    };

    return (
        <div className="cile-remessas">
            <div className="row">
                <div className="col-12 py-2">
                    <div className="row no-gutters align-items-center">
                        <div className="col-12 col-lg-8 text-center text-lg-left">
                            {props.location.state ?
                                <h2 className="title-1 d-none d-lg-block">CILE - Editar Banner</h2>
                                :
                                <h2 className="title-1 d-none d-lg-block">CILE - Adicionar Banner</h2>
                            }
                        </div>
                        <div className="col-12 col-lg-4 text-center text-lg-right">
                            <div className="row no-gutters">
                                <div className="col py-2 py-lg-0">
                                    <button onClick={() => window.history.go(-1)} className="btn btn-outline-secondary">voltar</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="card">
                <div className="row no-gutters px-3">
                    {formState.imagem ?
                        <div className="col-4 d-lg-block d-none pr-3 ">
                            <p className="pt-3"><strong>Imagem atual</strong></p>
                            <ImagemFukyo
                                className={`img img-fluid`}
                                src={props.location.state ? `https://api.ciledigital.com.br/file/banner/${formState.imagem}?v=${Math.random() * 123}` : `https://meubs.com.br/cile/cile-digital/banners/${formState.imagem}`}
                                alt={`imagem-destaque`}
                            />
                            <div className="d-flex justify-content-around">
                                <div className="ml-2">
                                    <label className="pt-3"><strong>Início da exibição:</strong></label>
                                    <SingleDatePicker
                                        date={dataI ? (moment.isMoment(dataI) ? dataI : moment(dataI)) : null}
                                        onDateChange={onDateChangeI}
                                        focused={focusedI}
                                        onFocusChange={({ focused }) => setFocusedI(focused)}
                                        id="dtlancamento"
                                        verticalHeight={450}
                                        numberOfMonths={1}
                                        small={true}
                                        isOutsideRange={_outsideRange}
                                        placeholder=""
                                        block={true}
                                    />
                                </div>
                                <div className="mr-2">
                                    <label className="pt-3"><strong>Fim da exibição:</strong></label>
                                    <SingleDatePicker
                                        date={dataF ? (moment.isMoment(dataF) ? dataF : moment(dataF)) : null}
                                        onDateChange={onDateChangeF}
                                        focused={focusedF}
                                        onFocusChange={({ focused }) => setFocusedF(focused)}
                                        id="dtlancamento"
                                        verticalHeight={450}
                                        numberOfMonths={1}
                                        small={true}
                                        isOutsideRange={_outsideRange}
                                        placeholder=""
                                        block={true}
                                        disabled={checked}
                                    />
                                    <label className="d-flex align-items-center cursor-pointer mt-2 ml-4">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            name="access-level"
                                            onChange={handleChecked}
                                        />
                                        <span className="pt-1">Data não definida</span>
                                    </label>
                                </div>
                            </div>
                        </div>
                        : null}

                    <div className={'py-3 ' + (formState.imagem ? 'col-8' : 'col-12')}>
                        {youtube || tipo === 'youtube' ?
                            <>
                                <label className="pl-2"><strong>Redirecionar para:</strong></label>
                               {props.location.state ? 
                                <p className="pl-2"><strong></strong> <a href={props.location.state.linkYoutube} target="_blank" rel="noopener noreferrer">{props.location.state.linkYoutube}</a> </p>
                            : null}
                                <p className="pl-2" style={{ fontSize: '14px' }}>O link é alterado com base no último vídeo que foi publicado</p>
                                
                                <button onClick={() => props.history.push('/cile/conteudo/videos?pagina=1&limite=10')} className="btn btn-outline-info">Lista de vídeos</button>
                            </>
                            :
                            <>
                                <label className="pl-2"><strong>Redirecionar para:</strong></label>
                                <p className="pl-2" style={{ fontSize: '14px' }}>Inserir somente link a partir do ".com.br". Ex: /meus-livros</p>
                                <input name="url" type="text" className="form-control" autoComplete="off" defaultValue={link ? link : ''} value={formState.url} onChange={handleInputChange} required={true} />
                            </>
                        }


                        <div className="row no-gutters">
                            <div className={`${props.location.state ? 'col-12' : 'col-lg-7'} mt-3`}>
                                <label className="pl-2"><strong>Título da imagem:</strong></label>
                                <ul>
                                    <li className="pl-2 m-0" style={{ fontSize: '14px' }}>Usar traço (-) para fazer a separação das palavras</li>
                                    <li className="pl-2 m-0" style={{ fontSize: '14px' }}>{youtube ? "Para banners do YouTube, iniciar com a palavra \"youtube\"" : "Para novos livros, iniciar com a palavra \"lançamento\""}</li>
                                </ul>

                                <p className="pl-2" style={{ fontSize: '14px' }}>Exemplo: {youtube ? 'youtube-escolha-a-vida' : 'lancamento-a-vida-de-daisaku-ikeda'}</p>
                                {temArquivo && <input name="url" type="text" className="form-control" autoComplete="off" value={imageName} onChange={handleImageChange} required={true} />}


                                <label className="pl-2 pt-3"><strong>Imagem:</strong></label>
                                {youtube && <p className="pl-2 m-0" style={{ fontSize: '14px' }}>Realizar somente o upload de imagens .jpg</p>}
                                <br />
                                <input type="file" accept={youtube ? ".jpg" : ".jpg,.jpeg,.png"} className="pb-3" onChange={onSelectFileImage} />
                                <br />
                                {temArquivo ?
                                    loadingSalvar ?
                                        <div className="spinner-border text-success" role="status" />
                                        :
                                        <div>
                                            <button onClick={() => salvarImg()} disabled={!imageName} className="btn btn-outline-success pl-3">salvar imagem</button>
                                            {mensagemSalvar && <small className="text-danger ml-3">Necessário salvar imagem</small>}
                                        </div>
                                    : null}
                            </div>
                            {props.location.state ?
                                null
                                :
                                <div className="col-lg-5 d-lg-block d-none pl-3 mt-3">
                                    <p className="mb-2"><strong>Tipo do banner:</strong></p>
                                    <label>
                                        <input
                                            type="radio"
                                            name="tipo"
                                            value="welcome"
                                            checked={tipo === "welcome"}
                                            onChange={handleChange}
                                            className="mr-1"
                                        />
                                        Carrossel
                                    </label>

                                    <label style={{ marginLeft: "12px" }}>
                                        <input
                                            type="radio"
                                            name="tipo"
                                            value="youtube"
                                            checked={tipo === "youtube"}
                                            onChange={handleChange}
                                            className="mr-1"
                                        />
                                        YouTube
                                    </label>
                                </div>}
                        </div>
                    </div>
                    <div className='col-12 text-right py-2'>
                        {loading ? <div className="spinner-border text-success" role="status" />
                            :
                            <button className='btn btn-outline-success' disabled={youtube ? false : !podeSalvar()}
                                onClick={() => props.location.state ? EditarBanner() : AdicionarBanner()} >
                                {props.location.state ? 'Salvar banner' : 'Incluir banner'}
                            </button>
                        }

                    </div>

                </div>



            </div>


            <Modal isOpen={modalSuccessYoutube} toggle={toggleModal}>
                <ModalHeader toggle={toggleModal}>
                    CILE - Banner
                </ModalHeader>
                <ModalBody>
                    Banner atualizado com sucesso!
                </ModalBody>
                <ModalFooter>
                    <Button color="success" onClick={toggleModal}>ok</Button>
                </ModalFooter>
            </Modal>
        </div>
    )
}


export default withRouter(CileContentBannersDetails);